import MyAccountViewContainer from "./MyAccountViewContainer";

export default MyAccountViewContainer;